import { FunctionComponent, useState } from "react";

import { PermissionCheck } from "@/components";

import { PermissionRoles } from "@/enum";

import { ButtonColor, ButtonSize } from "@/components/Button/types";
import { Button } from "@/components/Button/Button";

import { DeepResearchPromptsTable } from "./components/DeepResearchPromptsTable";
import { CreateDeepResearchPromptModal } from "./components/CreateDeepResearchPromptModal";

export const DeepResearchPrompts: FunctionComponent = () => {
	const [isCreateModalOpen, setIsCreateModalOpen] = useState<boolean>(false);

	return (
		<div className="sm:block flex flex-col items-start justify-between mb-6">
			<div className="flex flex-row justify-between w-full mb-4">
				<div className="flex flex-col items-start justify-start grow">
					<div className="text-md mb-2 whitespace-nowrap">Deep Research Prompts</div>
					<div className="text-sm text-text-meta">
						Manage deep research prompt templates for your research workflows.
					</div>
				</div>
				<div className="flex items-end justify-end mb-8">
					<div className="flex justify-end">
						<PermissionCheck requiredPermissions={[PermissionRoles.DEEP_RESEARCH]}>
							<Button
								color={ButtonColor.ACTION}
								size={ButtonSize.S}
								testId="new-deep-research-prompt-button"
								title="Create new Deep Research Prompt"
								onClick={() => setIsCreateModalOpen(true)}
							/>
						</PermissionCheck>
					</div>
				</div>
			</div>
			<DeepResearchPromptsTable />
			{isCreateModalOpen && (
				<CreateDeepResearchPromptModal
					isOpen={isCreateModalOpen}
					setIsOpen={setIsCreateModalOpen}
				/>
			)}
		</div>
	);
};
